import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import NewOrderFileUploadDialogNew from "./NewOrderFileUploadDialogNew";
import {
  Grid,
  TextField,
  MenuItem,
  Button,
  FormControl,
  InputLabel,
  Select,
  Divider,
} from "@mui/material";
export default function NewOrderFormNew(props) {
  const [showDialog, setShowDialog] = useState(false);
  const [fileData, setFileData] = useState(null);

  const handleFileUpload = (data) => {
    setFileData(data);
  };

  const handleBulkOrdersClick = () => {
    setShowDialog(true);
  };

  const handleDialogClose = (data) => {
    setShowDialog(false);
    if (data) {
      handleFileUpload(data);
    }
  };

  const [etkKits, setEtkKits] = useState(props.kits);
  const { register, handleSubmit, watch, formState } = useForm({
    defaultValues: props.model,
    etkKits: props.kits,
    mode: "onChange",
  });
  //Empty useEffect to trigger reload on orderNumber being set
  useEffect(() => {
    setEtkKits(props.kits);
  }, [props.model, props.kits]);

  let orderType = watch("orderType");

  return (
    <>
      <form onSubmit={handleSubmit(props.onSubmit)}>
        <Grid container spacing={2}>
          {/* Bulk Orders Button */}
          <Grid item xs={12}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleBulkOrdersClick}
            >
              Bulk Orders using File
            </Button>
          </Grid>

          <Grid item xs={12}>
            <Divider />
          </Grid>

          {/* Sample Type Selection */}
          <Grid item xs={12} md={4}>
            <FormControl fullWidth size="small">
              <InputLabel>Sample Type</InputLabel>
              <Select
                label="Sample Type"
                {...register("orderType", { required: true })}
              >
                <MenuItem value=""></MenuItem>
                {props.accountType?.toLowerCase().trim().includes("etk") ? (
                  <MenuItem value="ETK">ETK</MenuItem>
                ) : (
                  [
                    <MenuItem key="Micro" value="Micro">
                      Micro
                    </MenuItem>,
                    <MenuItem key="Chemistry" value="Chemistry">
                      Chemistry
                    </MenuItem>,
                  ]
                )}
              </Select>
            </FormControl>
          </Grid>

          {orderType === "Micro" && (
            <>
              <Grid item xs={12} md={4}>
                <FormControl fullWidth size="small">
                  <InputLabel>Type</InputLabel>
                  <Select
                    label="Type"
                    {...register("sampleType", { required: true })}
                  >
                    <MenuItem value="Pool">Pool</MenuItem>
                    <MenuItem value="Coliform">Coliform</MenuItem>
                    <MenuItem value="Ecoli">Ecoli</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} md={4}>
                <TextField
                  size="small"
                  label="Sample Count"
                  type="number"
                  {...register("sampleCount", { required: true, min: 1 })}
                  fullWidth
                />
              </Grid>
            </>
          )}

          {orderType === "ETK" && (
            <>
              <Grid item xs={12} md={4}>
                <FormControl fullWidth size="small">
                  <InputLabel>Kit Type</InputLabel>
                  <Select
                    label="Kit Type"
                    {...register("sampleType", { required: true })}
                  >
                    {etkKits.map((u, index) => {
                      const capitalizedOption =
                        u.vlpName.charAt(0).toUpperCase() +
                        u.vlpName.slice(1).toLowerCase();
                      return (
                        <MenuItem key={index} value={u.vlpName}>
                          {capitalizedOption}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} md={4}>
                <FormControl fullWidth size="small">
                  <InputLabel>Pay Type</InputLabel>
                  <Select
                    label="Pay Type"
                    {...register("payType", { required: true })}
                  >
                    <MenuItem value=""></MenuItem>
                    <MenuItem value="pre-pay">At Purchase</MenuItem>
                    <MenuItem value="post-pay">After Purchase</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} md={4}>
                <TextField
                  size="small"
                  label="Test Kit Count"
                  type="number"
                  {...register("sampleCount", { required: true, min: 1 })}
                  fullWidth
                />
              </Grid>
            </>
          )}

          {orderType === "Chemistry" && (
            <Grid item xs={12} md={4}>
              <TextField
                size="small"
                label="Sample Count"
                type="number"
                {...register("sampleCount", { required: true, min: 1 })}
                fullWidth
              />
            </Grid>
          )}

          {/* ETK Print QR Labels */}
          {props.orderNumber && orderType === "ETK" && (
            <Grid item xs={12} md={4}>
              <Button
                size="small"
                variant="contained"
                color="primary"
                onClick={props.handlePrintOrderNumberQRLabels}
              >
                Print Order Number QR Labels
              </Button>
            </Grid>
          )}

          {/* Order Actions */}
          {props.orderNumber && orderType !== "ETK" && (
            <>
              <Grid item xs={12} md={4}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={props.handlePrintOrderNumber}
                >
                  Order Number
                </Button>
              </Grid>
              <Grid item xs={12} md={4}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={props.handlePrint}
                >
                  Sample Barcode
                </Button>
              </Grid>
              <Grid item xs={12} md={4}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={props.handleCheckInPrint}
                >
                  Check-In Label
                </Button>
              </Grid>
            </>
          )}

          <Grid item xs={12} md={4}>
            <Button
              variant="contained"
              color="success"
              type="submit"
              disabled={!formState.isValid || props.orderNumber}
            >
              Submit
            </Button>
          </Grid>
        </Grid>
      </form>

      {showDialog && (
        <NewOrderFileUploadDialogNew
          time={props.time}
          user={props.user}
          accountNumber={props.accountNumber}
          onClose={handleDialogClose}
        />
      )}
    </>
  );
}
